// Eligibility rules for the Verified Badge. Used by:
//  - Admin Managers tab (grants are blocked unless eligible)
//  - Pricing page (so property management self-select)
//  - Property Management Dashboard (so the property management sees their status)
//
// Phase 2: a nightly job will re-run isEligibleForBadge on every
// holder; if they've been failing for 30+ days, auto-revoke.

export const BADGE_PRICE_USD          = 49.99;
export const BADGE_MIN_RATING         = 4.0;
export const BADGE_MIN_REVIEWS        = 3;
export const BADGE_MIN_ACCOUNT_AGE_DAYS = 60;

export function isEligibleForBadge(manager, opts = {}) {
  const failing = [];
  if (!manager) return { eligible: false, failing: ['No property management profile found'] };

  const rating  = Number(manager.rating)       || 0;
  const reviews = Number(manager.review_count) || 0;

  if (rating < BADGE_MIN_RATING) {
    failing.push(`Rating ${rating.toFixed(1)} — need ${BADGE_MIN_RATING.toFixed(1)}+`);
  }
  if (reviews < BADGE_MIN_REVIEWS) {
    failing.push(`${reviews} review${reviews === 1 ? '' : 's'} — need ${BADGE_MIN_REVIEWS}+`);
  }
  if (manager.created_at) {
    const ageDays = Math.floor((Date.now() - new Date(manager.created_at).getTime()) / 86400000);
    if (ageDays < BADGE_MIN_ACCOUNT_AGE_DAYS) {
      failing.push(`Account age ${ageDays}d — need ${BADGE_MIN_ACCOUNT_AGE_DAYS}d+`);
    }
  }
  if (opts.suspended) {
    failing.push('Account is suspended');
  }
  // TODO: when disputes / flagged-reviews are modeled, fail eligibility
  // if there's an unresolved flag in the last 90 days.

  return { eligible: failing.length === 0, failing };
}

// Short human-friendly summary for badges/tooltips.
export function eligibilitySummary(result) {
  if (result.eligible) return 'Eligible';
  return 'Not eligible: ' + result.failing.join(' · ');
}
